import {
  ComponentBuilder,
  ComponentBuilderFetchDataInputs,
} from 'strapi/componentBuilder';

import { collectFrequentlyAskedQuestionsComponentParams } from './collector';
import { FrequentlyAskedQuestions } from './FrequentlyAskedQuestions';
import { FrequentlyAskedQuestionsStrapiComponent } from './types';

export class FaqComponentBuilder extends ComponentBuilder {
  public key = 'help.frequently-asked-questions' as const;

  async fetchData(inputs: ComponentBuilderFetchDataInputs) {
    const fieldName = this.getFieldNameSymbol(inputs.componentData);

    const page = await inputs.fetchManager.addRequestOptionsAndWaitForResponse<{
      fieldName: FrequentlyAskedQuestionsStrapiComponent;
    }>({
      populate: {
        [fieldName]: {
          populate: {
            items: true,
          },
        },
      },
    });
    const componentData = page[fieldName];
    if (!componentData) {
      return undefined;
    }
    const collectedParams =
      collectFrequentlyAskedQuestionsComponentParams(componentData);

    return collectedParams;
  }

  render(inputs: Awaited<ReturnType<(typeof this)['fetchData']>>) {
    if (inputs) {
      return <FrequentlyAskedQuestions {...inputs} />;
    } else {
      return null;
    }
  }
}
